import { createStructuredSelector } from 'reselect';

const dialSettingConfigStore = state => state.dialDataStore && state.dialDataStore.dialSettingConfig;

const dialSettingConfigSelector = createStructuredSelector({
  dialSettingConfig: dialSettingConfigStore
});

export { dialSettingConfigSelector };
